"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorSelector = void 0;
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var colorSelector = function (props, color, intensity) {
    return escapeCss_1.default(props.theme.colors[color]["$" + String(intensity).padStart(3, "0")]);
};
exports.colorSelector = colorSelector;
var getColor = function (color, intensity) {
    return function (props) { return exports.colorSelector(props, color, intensity); };
};
exports.default = getColor;
//# sourceMappingURL=index.js.map